import React, {useEffect ,useState, useRef } from "react";
import { TextField } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { Login, ResetGameProgress } from "../../redux/action/action";
import ReCAPTCHA from "react-google-recaptcha";
import { connect } from "react-redux";
import { withParams } from "../../utils/withParams";
import VirtualKeyboard from "./VirtualKeyboard";
import {
  ClientId,
  SecretId,
  API_Prefix,
  REACT_APP_SITE_KEY,
} from "../config/config";

let server_url = `${API_Prefix}/o/`;
let data = `grant_type=client_credentials&client_id=${ClientId}&client_secret=${SecretId}`;
let accessToken = null;
let credentails = null;

const Loginform = (props) => {
 const navigate = useNavigate();
  const recaptchaRef = useRef(null);
  const navigationRef = useRef(false); // Prevent multiple navigations

  // Form validation states
  const [required, setRequired] = useState(false);
  const [anotherEmail, anotherEmailRequired] = useState(false);
  const [corporateEmail, setCorporateEmail] = useState(false);
  const [emailRequired, setEmailRequired] = useState(false);
  const [nameRequired, setNameRequired] = useState(false);

  // Form data and loading states
  const [state, setstate] = useState({ name: "", email: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [activeField, setActiveField] = useState(null);
  const isTouchDevice =
    typeof window !== "undefined" &&
    (window.matchMedia("(pointer: coarse)").matches ||
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0);

  // reCAPTCHA states
  const [captchaError, setCaptchaError] = useState("");

  useEffect(() => {
    // Get access token
    fetch(server_url + "oauth2/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: data,
    })
      .then((response) => response.json())
      .then((json) => {
        accessToken = json.access_token;
      })
      .catch((error) => {
        console.error('Error getting access token:', error);
      });
  }, []);

  // Single useEffect to handle both initial check and login response
  const onCaptchaChange = async (token) => {
    if (token) {
      // reCAPTCHA completed successfully, now make API call
      try {
        const loginData = {
          name: state.name,
          email: state.email,
          token: token,
        };

        // Clear any previous errors
        setCaptchaError("");

        // A successful login here is this flow's explicit "start a (new)
        // playthrough" signal — reset cumulative progress totals before
        // dispatching the login itself.
        props.ResetGameProgress();
        // Dispatch login action - don't check response immediately
        props.Login(loginData, accessToken);

        // Don't check the state here, let the useEffect handle it
      } catch (error) {
        console.error('Login failed:', error);
        setCaptchaError("Login failed. Please check your details and try again.");

        // Reset reCAPTCHA for retry
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
        setIsLoading(false);
      }
    } else {
      // reCAPTCHA failed
      setCaptchaError("reCAPTCHA verification failed. Please try again.");
      setIsLoading(false);
    }
  };

  // Handle reCAPTCHA expiration
  const onCaptchaExpired = () => {

    setCaptchaError("reCAPTCHA expired. Please try again.");
    setIsLoading(false);
  };

  // Handle reCAPTCHA error
  const onCaptchaError = () => {
    setCaptchaError("reCAPTCHA failed to load. Please try again.");
    setIsLoading(false);
  };

  const handleNavigation = async (e) => {
    e.preventDefault();

    const formData = {
      name: state.name,
      email: state.email,
    };

    // Reset all error states
    setEmailRequired(false);
    setNameRequired(false);
    setCorporateEmail(false);
    anotherEmailRequired(false);
    setCaptchaError("");

    let hasError = false;

    // Validate form fields
    if (formData.name === "") {
      setNameRequired(true);
      hasError = true;
    }
    if (formData.email === "") {
      setEmailRequired(true);
      hasError = true;
    }

    if (hasError) return;

    // Check for corporate email
    if (
      formData.email.indexOf("@gmail.com") > 0 ||
      formData.email.indexOf("@hotmail.com") > 0 ||
      formData.email.indexOf("@ymail.com") > 0 ||
      formData.email.indexOf("@live.com") > 0 ||
      formData.email.indexOf("@yahoo.com") > 0 ||
      formData.email.indexOf("@outlook.com") > 0
    ) {
      setCorporateEmail(true);
      return;
    }

    // Validate email format
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formData.email)) {
      setEmailRequired(true);
      return;
    }

    // All validations passed, trigger reCAPTCHA
    setIsLoading(true);

    try {
      if (recaptchaRef.current) {
        // Execute reCAPTCHA which will show the image challenge
        recaptchaRef.current.execute();
      } else {
        throw new Error('reCAPTCHA not initialized');
      }
    } catch (error) {
      console.error('Failed to trigger reCAPTCHA:', error);
      setCaptchaError("Failed to load reCAPTCHA. Please refresh the page.");
      setIsLoading(false);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setstate((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Hide error messages when user starts typing
    if (name === "name") {
      setNameRequired(false);
    }
    if (name === "email") {
      setEmailRequired(false);
      setCorporateEmail(false);
    }
  };

  const handleVirtualKeyPress = (char) => {
    if (!activeField) return;
    setstate((prevState) => ({
      ...prevState,
      [activeField]: prevState[activeField] + char,
    }));
    if (activeField === "name") setNameRequired(false);
    if (activeField === "email") {
      setEmailRequired(false);
      setCorporateEmail(false);
    }
  };

  const handleVirtualBackspace = () => {
    if (!activeField) return;
    setstate((prevState) => ({
      ...prevState,
      [activeField]: prevState[activeField].slice(0, -1),
    }));
  };

  const handleVirtualSpace = () => handleVirtualKeyPress(" ");

  const handleVirtualDone = () => setActiveField(null);

  // Single useEffect to handle both initial check and login response
  useEffect(() => {
    // Handle successful login - prevent multiple navigations
    if (
      props.prGameAttendeeId &&
      props.prGameAttendeeId.data &&
      props.prGameAttendeeId.data.status === "true" &&
      !navigationRef.current
    ) {
      navigationRef.current = true; // Mark as navigated
      setCaptchaError("");
      setIsLoading(false);

      // Navigate immediately without timeout
      navigate(withParams("/cyberisland/instruction"));
    }
    // Handle login error
    else if (props.loginError && !props.loginLoading) {
      setCaptchaError("Login failed. Please check your details and try again.");
      setIsLoading(false);

      // Reset reCAPTCHA for retry
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
    }
  }, [props.prGameAttendeeId, props.loginError, props.loginLoading, navigate]);


  return (
    <section className="login-bg">
      <div className="container-fluid">
        <div className="d-flex justify-content-center align-items-center vh-100">
          <form className="login-form-bg">
            <div className="d-flex flex-row align-items-center justify-content-center signup">
              <h1 className="lead fw-normal mb-0 me-3">Sign Up</h1>
            </div>
            <div className="inner-div">
              <div className="form-outline mb-4">
                <TextField
                  inputProps={{
                    autoComplete: "new-name",
                  }}
                  size="small"
                  label="Enter Name"
                  variant="filled"
                  fullWidth
                  type="text"
                  name="name"
                  value={state.name}
                  onChange={handleChange}
                  onFocus={() => setActiveField("name")}
                  disabled={isLoading}
                />
               {nameRequired && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    Please enter name
                  </span>
                )}
              </div>
              <div className="form-outline mb-3">
                <TextField
                  inputProps={{
                    autoComplete: "new-email",
                  }}
                  size="small"
                  label="Enter Email"
                  variant="filled"
                  fullWidth
                  name="email"
                  type="email"
                  value={state.email}
                  onChange={handleChange}
                  onFocus={() => setActiveField("email")}
                   disabled={isLoading}
                />
                {emailRequired && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    Please enter valid email
                  </span>
                )}
                {corporateEmail && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    Please enter a corporate Email
                  </span>
                )}
              </div>

              <div className="text-center text-lg-start mt-4 pt-2 set-btn">
                <Button
                  type="submit"
                  size="large"
                  variant="contained"
                  onClick={handleNavigation}
                  disabled={isLoading}
                  style={{
                    opacity: isLoading ? 0.7 : 1,
                    cursor: isLoading ? 'not-allowed' : 'pointer'
                  }}
                >
                  {isLoading ? "VERIFYING..." : "LET'S PLAY"}
                </Button>
              </div>

               {/* Show error messages */}
              {captchaError && (
                <div style={{
                  color: 'red',
                  textAlign: 'center',
                  marginTop: '10px',
                  fontSize: '14px'
                }}>
                  {captchaError}
                </div>
              )}

              {/* Show loading state */}
              {(isLoading || props.loginLoading) && (
                <div style={{ textAlign: 'center', marginTop: '10px', color: '#666' }}>
                  <span>Processing login...</span>
                </div>
              )}

              {/* Success message */}
              {props.prGameAttendeeId && props.prGameAttendeeId.data && props.prGameAttendeeId.data.status === "true" && (
                <div style={{
                  color: 'green',
                  textAlign: 'center',
                  marginTop: '10px',
                  fontSize: '14px',
                  padding: '10px',
                  backgroundColor: '#e6ffe6',
                  borderRadius: '4px'
                }}>
                  Login successful! Redirecting...
                </div>
              )}
            </div>
          </form>
        </div>

        {/* Invisible reCAPTCHA - Badge appears in bottom right corner */}
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={REACT_APP_SITE_KEY}
          onChange={onCaptchaChange}
          onExpired={onCaptchaExpired}
          onError={onCaptchaError}
          size="invisible"
          badge="bottomright"
        />
      </div>

      {isTouchDevice && activeField && (
        <VirtualKeyboard
          onKeyPress={handleVirtualKeyPress}
          onBackspace={handleVirtualBackspace}
          onSpace={handleVirtualSpace}
          onDone={handleVirtualDone}
        />
      )}
    </section>
  );
};
const mapStateToProps = (state) => {
  return {
    prGameAttendeeId: state.GameReducer.login,
  };
};
export default connect(mapStateToProps, { Login, ResetGameProgress })(Loginform);
